function initProductForm(form) {
  const select = form.querySelector('#fmt');
  const hiddenId = form.querySelector('input[name="id"]');
  const priceEl = document.getElementById('price');
  const addedMsg = document.getElementById('added-msg');
  const addBtn = form.querySelector('#add-btn');

  function syncAvailability(option) {
    if (!addBtn || !option) return;
    const available = option.dataset.available === 'true';
    addBtn.textContent = available ? addBtn.dataset.labelAvailable : addBtn.dataset.labelSoldout;
    addBtn.disabled = !available;
  }

  select?.addEventListener('change', () => {
    const option = select.selectedOptions[0];
    if (addedMsg) addedMsg.classList.remove('show');
    syncAvailability(option);
    if (priceEl && option) {
      priceEl.classList.add('swap');
      setTimeout(() => {
        priceEl.textContent = option.dataset.price;
        priceEl.classList.remove('swap');
      }, 160);
    }
  });

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const variantId = select ? select.value : hiddenId?.value;
    if (!variantId) return;
    if (select && select.selectedOptions[0]?.dataset.available !== 'true') return;
    addBtn?.setAttribute('disabled', 'disabled');
    try {
      await window.KamCart.addToCart(variantId, 1);
      if (addedMsg) addedMsg.classList.add('show');
    } catch (error) {
      if (addedMsg) {
        addedMsg.textContent = error.message;
        addedMsg.classList.add('show');
      }
    } finally {
      if (select) syncAvailability(select.selectedOptions[0]);
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('form[data-product-form]').forEach(initProductForm);
});
